import { Component } from '@angular/core';

@Component({
  selector: 'screening-next-steps',
  standalone: true,
  imports: [],
  templateUrl: './next-steps.component.html',
  styleUrl: './next-steps.component.css'
})
export class ScreeningNextStepsComponent {

}
